/* eslint-disable camelcase */
import APIClient from '@/shared/http/clients/api'

const baseResourceNameV2 = 'api/v2'
const APIBase = process.env.APIBaseBPM

const resourceNameBoard = `${baseResourceNameV2}/board`
const resourceNameColumn = (boardId) => `${resourceNameBoard}/${boardId}/columns`
const resourceNameCard = (boardId, columnId) => `${resourceNameColumn(boardId)}/${columnId}/cards`

const Column_GetAll = (boardId, data = {}, config = {}) => APIClient.get(`${APIBase}/${resourceNameColumn(boardId)}/?sort=posicao,asc&size=500`, data, config)
const Column_GetAllByPaging = (boardId, index, limit, data = {}, config = {}) => APIClient.get(`${APIBase}/${resourceNameColumn(boardId)}/?sort=posicao,asc&page=${index}&size=${limit}`, data, config)
const Column_GetAllActive = (boardId, data = {}, config = {}) => APIClient.get(`${APIBase}/${resourceNameColumn(boardId)}/?inative=0&sort=name,asc&size=500`, data, config)
const Column_GetById = (boardId, columnId, config = {}) => APIClient.get(`${APIBase}/${resourceNameColumn(boardId)}/${columnId}`, config)
const Column_Create = (boardId, data = {}, config = {}) => APIClient.post(`${APIBase}/${resourceNameColumn(boardId)}/`, data, config)
const Column_Update = (boardId, columnId, data = {}, config = {}) => APIClient.put(`${APIBase}/${resourceNameColumn(boardId)}/${columnId}`, data, config)
const Column_Delete = (boardId, columnId, config = {}) => APIClient.delete(`${APIBase}/${resourceNameColumn(boardId)}/${columnId}`, config)

const Card_GetAllByBoardAndPaging = (boardId, boardArquivado = false, situacao = {}, filter = '', limit, index, sortValue = 'posicao', config = {}) => APIClient.get(`${APIBase}/${resourceNameBoard}/${boardId}/cards/?boardArquivado=${boardArquivado}&situacao=${situacao}${filter != null ? filter : ''}&page=${index}&size=${limit}&${!sortValue.includes('somaSaldoDevedor') && !sortValue.includes('sortDiasAtraso') ? 'sort=' : ''}${sortValue}`, config)
const Card_GetAllByPaging = (boardId, columnId, boardArquivado = false, situacao = 1, filter = '', limit, index, sortValue = 'posicao', config = {}) => {
  const url = `${APIBase}/${resourceNameCard(boardId, columnId)}/?boardArquivado=${boardArquivado}&situacao=${situacao}${filter != null ? filter : ''}&page=${index}&size=${limit}&sort=${sortValue}`
  return APIClient.get(url, config)
}
const Card_GetAll = (boardId, columnId, config = {}) => APIClient.get(`${APIBase}/${resourceNameCard(boardId, columnId)}/?sort=name,asc&size=500`, config)
const Card_GetAllByDocumentAndPaging = (boardId, columnId, document, filter = '', limit, index, sortValue = 'dataCriacao,desc', config = {}) => APIClient.get(`${APIBase}/${resourceNameCard(boardId, columnId)}/?document=${document}${filter != null ? filter : ''}&page=${index}&size=${limit}&sort=${sortValue}`, config)
const Card_GetById = (boardId, columnId, cardId, config = {}) => APIClient.get(`${APIBase}/${resourceNameCard(boardId, columnId)}/${cardId}`, config)
const Card_Create = (boardId, columnId, data = {}, config = {}) => APIClient.post(`${APIBase}/${resourceNameCard(boardId, columnId)}/`, data, config)
const Card_CreateCardAndPerson = (boardId, columnId, data = {}, config = {}) => APIClient.post(`${APIBase}/${resourceNameCard(boardId, columnId)}/person`, data, config)
const Card_CreateNotifications = (boardId, columnId, cardId, data = {}, config = {}) => APIClient.post(`${APIBase}/${resourceNameCard(boardId, columnId)}/${cardId}/notifications`, data, config)
const Card_MoveCardColumns = (boardId, columnId, cardId, data = {}, config = {}) => APIClient.put(`${APIBase}/${resourceNameCard(boardId, columnId)}/${cardId}/move-column`, data, config)
const Card_MoveCardBoard = (boardId, columnId, cardId, data = {}, config = {}) => APIClient.put(`${APIBase}/${resourceNameCard(boardId, columnId)}/${cardId}/move-board`, data, config)
const Card_PatchSituacao = (boardId, columnId, cardId, data = {}, config = {}) => APIClient.patch(`${APIBase}/${resourceNameCard(boardId, columnId)}/${cardId}/change-status`, data, config)
const Card_PatchLeadOwner = (boardId, columnId, cardId, data = {}, config = {}) => APIClient.patch(`${APIBase}/${resourceNameCard(boardId, columnId)}/${cardId}/update-leadowner`, data, config)
const Card_PatchObservation = (boardId, columnId, cardId, data = {}, config = {}) => APIClient.patch(`${APIBase}/${resourceNameCard(boardId, columnId)}/${cardId}/observacao`, data, config)
const Card_PatchDescription = (boardId, columnId, cardId, data = {}, config = {}) => APIClient.patch(`${APIBase}/${resourceNameCard(boardId, columnId)}/${cardId}/descricao`, data, config)
const Card_PatchReadOnlyToFalse = (boardId, columnId, cardId, data = {}, config = {}) => APIClient.patch(`${APIBase}/${resourceNameCard(boardId, columnId)}/${cardId}/read-only/disable`, data, config)
const Card_Update = (boardId, columnId, cardId, data = {}, config = {}) => APIClient.put(`${APIBase}/${resourceNameCard(boardId, columnId)}/${cardId}`, data, config)
const Card_Delete = (boardId, columnId, cardId, config = {}) => APIClient.delete(`${APIBase}/${resourceNameCard(boardId, columnId)}/${cardId}`, config)

const BoardRepository = {
  Column_GetAll,
  Column_GetAllByPaging,
  Column_GetAllActive,
  Column_GetById,
  Column_Create,
  Column_Update,
  Column_Delete,

  Card_GetAllByBoardAndPaging,
  Card_GetAllByDocumentAndPaging,
  Card_GetAll,
  Card_GetAllByPaging,
  Card_GetById,
  Card_Create,
  Card_CreateCardAndPerson,
  Card_CreateNotifications,
  Card_MoveCardColumns,
  Card_MoveCardBoard,
  Card_PatchSituacao,
  Card_PatchLeadOwner,
  Card_PatchObservation,
  Card_PatchDescription,
  Card_PatchReadOnlyToFalse,
  Card_Update,
  Card_Delete
}

export default BoardRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/crm/board_v2.js